/**
 * Validation utilities for PostHog events
 */

import { PosthogEventProperties } from '~/services/posthog';

/**
 * Validate event properties
 */
export const validateEventProperties = (
  properties: PosthogEventProperties | undefined
): PosthogEventProperties | undefined => {
  if (!properties) return undefined;

  // Remove any undefined or null values
  const cleaned: PosthogEventProperties = {};

  for (const [key, value] of Object.entries(properties)) {
    if (value !== undefined && value !== null) {
      // Limit string lengths to prevent excessive data
      if (typeof value === 'string' && value.length > 1000) {
        cleaned[key] = value.substring(0, 1000) + '...';
      } else {
        cleaned[key] = value;
      }
    }
  }

  return cleaned;
};

/**
 * Validate and limit array sizes in properties
 */
export const limitArraySizes = (
  properties: PosthogEventProperties,
  maxArraySize: number = 50
): PosthogEventProperties => {
  const limited: PosthogEventProperties = {};

  for (const [key, value] of Object.entries(properties)) {
    if (Array.isArray(value)) {
      // Limit array size and add indicator if truncated
      if (value.length > maxArraySize) {
        limited[key] = value.slice(0, maxArraySize);
        limited[`${key}_truncated`] = true;
        limited[`${key}_original_length`] = value.length;
      } else {
        limited[key] = value;
      }
    } else if (typeof value === 'object' && value !== null) {
      // Recursively handle nested objects
      limited[key] = limitArraySizes(value as PosthogEventProperties, maxArraySize);
    } else {
      limited[key] = value;
    }
  }

  return limited;
};